import { render } from "./BookBoardEntryNew.vue?vue&type=template&id=1abb8b2e&scoped=true"
import script from "./BookBoardEntryNew.vue?vue&type=script&lang=js"
export * from "./BookBoardEntryNew.vue?vue&type=script&lang=js"

import "./BookBoardEntryNew.vue?vue&type=style&index=0&id=1abb8b2e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1abb8b2e"]])

export default __exports__